import React, { useEffect, useState } from 'react';
import './Auth.css';
import { verifyCheckoutSession } from '../../Authentication Services/AuthService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

const Success = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('choosePlan');

  const [sessionId] = useState(() => getQueryParam('session_id') || '');
  const [status, setStatus] = useState('loading'); // loading | ok | pending | error
  const [message, setMessage] = useState(t('checkoutResult.messages.confirming'));

  const runVerify = async () => {
    if (!sessionId) {
      setStatus('error');
      setMessage(t('checkoutResult.messages.missingSession'));
      return;
    }

    setStatus('loading');
    setMessage(t('checkoutResult.messages.confirming'));

    try {
      const res = await verifyCheckoutSession(sessionId);
      const data = res?.data;

      if (data?.ok) {
        setStatus('ok');
        setMessage(t('checkoutResult.messages.ready'));
        return;
      }

      setStatus('pending');
      setMessage(t('checkoutResult.messages.processing'));
    } catch (e) {
      setStatus('error');
      setMessage(t('checkoutResult.messages.unableToConfirm'));
    }
  };

  useEffect(() => {
    runVerify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="login-background">
      <div className="login-container choose-plan-container">
        <h2 className="login-title">{t('checkoutResult.title')}</h2>
        <p className="login-subtitle">{message}</p>

        {status === 'loading' && (
          <div className="choose-plan-state">
            <div className="choose-plan-spinner" aria-hidden="true" />
            <div className="choose-plan-state-text">
              {t('checkoutResult.loadingHint')}
            </div>
          </div>
        )}

        {status === 'ok' && (
          <div className="success-actions">
            <div className="success-badge">
              {t('checkoutResult.badges.confirmed')}
            </div>

            <button className="signin-btn" onClick={() => navigate('/login')}>
              {t('checkoutResult.actions.continueToSignIn')}
            </button>
          </div>
        )}

        {status === 'pending' && (
          <div className="success-actions">
            <button className="signin-btn" onClick={runVerify}>
              {t('checkoutResult.actions.tryAgain')}
            </button>

            <div className="choose-plan-footer-links" style={{ marginTop: '0.75rem' }}>
              <a className="choose-plan-link" href="/choose-plan">
                {t('checkoutResult.actions.backToPlans')}
              </a>
              <span className="choose-plan-dot">•</span>
              <a className="choose-plan-link" href="/login">
                {t('actions.goToLogin')}
              </a>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="choose-plan-error">
            <div className="choose-plan-error-title">
              {t('checkoutResult.error.title')}
            </div>
            <div className="choose-plan-error-text">{message}</div>

            <div className="success-actions" style={{ marginTop: '1rem' }}>
              <button className="signin-btn" onClick={runVerify} disabled={!sessionId}>
                {t('checkoutResult.actions.tryAgain')}
              </button>

              <div className="choose-plan-footer-links" style={{ marginTop: '0.75rem' }}>
                <a className="choose-plan-link" href="/choose-plan">
                  {t('checkoutResult.actions.backToPlans')}
                </a>
                <span className="choose-plan-dot">•</span>
                <a className="choose-plan-link" href="/login">
                  {t('actions.goToLogin')}
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Success;